import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { apiSlice } from "./apiSlice";
import restaurantSlice from "./restaurantsSlice";
import menuSlice from "./menuSlice";
import setMenuSlice from "./setMenuSlice";
import menusSlice from "./menusSlice";
import customizeMenuSlice from "./customizeMenuSlice";
import menuTypeSlice from "./customMenuType";
import orderSlice from "./orderSlice";
import cartSlice from "./cartSlice";
import configurationMenuItemSlice from "./configurationMenuItemSlice";
import configurationCustomizeMenuSlice from "./configurationCustomizeMenuSlice";
import configurationComboMenuSlice from "./configurationComboMenuSlice";
import notificationSlice from "./notificationSlice";
import refundOrderSlice from "./refundOrderSlice";
import cartAllocationReducer from "./cartAllocationSlice";
import cartItemRequestReducer from "./cartItemRequestSlice";
import deliveryOrderSlice from "./deliveryOrderSlice";
import inAppCartOrderSlice from "./inAppCartOrderSlice";
import { AllocationService } from "./services/allocationService";


const persistConfig = {
  key: "root",
  storage,
    whitelist: ["restaurant", "notification", "menu", "setMenu", "customizeMenu", "cartItemRequest"],
};

const rootReducer = combineReducers({
  restaurant: restaurantSlice,
  menu: menuSlice,
  setMenu: setMenuSlice,
  menus: menusSlice,
  customizeMenu: customizeMenuSlice,
  menuType: menuTypeSlice,
  order: orderSlice,
  cart: cartSlice,
  configurationMenuItem: configurationMenuItemSlice,
  configurationComboMenu: configurationComboMenuSlice,
  refundOrder: refundOrderSlice,
  configurationCustomizeMenu: configurationCustomizeMenuSlice,
  notification: notificationSlice,
  cartAllocation: cartAllocationReducer,
  cartItemRequest: cartItemRequestReducer,
  deliveryOrder: deliveryOrderSlice,
  inAppCartOrder: inAppCartOrderSlice,
  allocation: AllocationService.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});


const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
